import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"
import { Italian } from "flatpickr/dist/l10n/it.js"

// Connects to data-controller="datepicker"
export default class extends Controller {
  static targets = ["input"]
  
  connect() {
    this.picker = flatpickr(this.inputTarget, {
      locale: Italian,
      dateFormat: "Y-m-d",
      allowInput: true
    })
  }
  
  open() {
    this.picker.open()
  }
}
